module.exports = {"href":"/corgi/pageapps/prepurchase/_next/public/sprite-7.27.0-de48ae84e.svg#arrow-down-strong-2","viewBox":"0 0 32 32"}